export default {
    name: 'InternalTransfer',

    props: {
        operation: {
            type: Object,
            required: true
        }
    }
};
